// Gera um ID único usando crypto seguro (compatível com React Native)
export const generateId = () => {
  // Use crypto.randomUUID if available (modern browsers/node)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback using crypto.getRandomValues (secure random)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // Version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // Variant 10
    const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  // Last resort fallback (should not reach here in modern environments)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};


// Formata tempo em segundos para MM:SS
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// Verifica se as alternativas selecionadas estão corretas
export const checkAnswer = (question, selectedAlternatives) => {
  // Se for questão do tipo Certo/Errado
  if (question.type === 'true-false') {
    // selectedAlternatives é um objeto: { itemId: 'C' ou 'E' }
    const allItemsAnswered = question.alternatives.every(
      (item) => selectedAlternatives[item.id]
    );

    if (!allItemsAnswered) {
      return false;
    }

    return question.alternatives.every((item) => {
      const userAnswer = selectedAlternatives[item.id];
      const correctAnswer = item.isCorrect ? 'C' : 'E';
      return userAnswer === correctAnswer;
    });
  }

  // Questões de múltipla escolha (comportamento original)
  const correctAlternatives = question.alternatives
    .filter((alt) => alt.isCorrect)
    .map((alt) => alt.id);

  if (correctAlternatives.length !== selectedAlternatives.length) {
    return false;
  }

  return correctAlternatives.every((id) => selectedAlternatives.includes(id));
};

// Ordena questões por data de criação (mais recentes primeiro)
export const sortByCreatedAt = (questions) => {
  return [...questions].sort((a, b) => b.createdAt - a.createdAt);
};


// Filtra questões por categorias
export const filterByCategories = (questions, categories) => {
  if (!categories || categories.length === 0) {
    return questions;
  }
  return questions.filter((q) => categories.includes(q.category));
};

// Agrupa questões por categoria
export const groupByCategory = (questions) => {
  return questions.reduce((groups, question) => {
    const category = question.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(question);
    return groups;
  }, {});
};



// Embaralha um array (Fisher-Yates shuffle)
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Embaralha as alternativas de uma questão (mantendo isCorrect intacto)
export const shuffleQuestionAlternatives = (question) => {
  return {
    ...question,
    alternatives: shuffleArray(question.alternatives),
  };
};

